import { useQuery } from 'react-query'

import { proxyService } from '@/modules/proxy/service/proxy-service.ts'
import { handleError } from '@/utils/error'

export function useProxyCountries() {
  const { data: proxyCountries, isLoading } = useQuery(
    'proxy-countries',
    async () => {
      return await proxyService.getProxyCountries()
    },
    {
      onError: (error) => handleError(error, 'Failed to get proxy countries'),
    },
  )

  return { proxyCountries, isLoading }
}
